import React, { useState } from "react";
import { ReactComponent as UnChecked } from "assets/img/icons/uncheckbox.svg";
import { ReactComponent as Checked } from "assets/img/icons/checkbox.svg";
import CustomInput from "components/CustomInput/CustomInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Yup from "yup";
import { useFormik } from "formik";
import { faLock, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Button from "components/CustomButton";
import Loader from "components/Loader";
import TeamService from "services/TeamService";
import { useGlobalContext } from "store/contexts/globalContext";

const styles = {
  icon: {
    width: "20px",
    height: "20px",
  },
  checkedBox: {
    display: "flex",
    gap: "5px",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  borderInput: {
    paddingBottom: "12px",
  },
};

export default () => {
  const classes = styles;
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
	const { handleLogout } = useGlobalContext();
  const [values, setValues] = useState({
    password: "",
    showPassword: false,
  });
  const passwordStyle = {
    marginTop: "0.5rem",
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const formik = useFormik({
    initialValues: {
      password: "",
    },
    validateOnBlur: false,
    validationSchema: loginValidationSchema(),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        await TeamService.deleteAccount(values.password);
				await handleLogout();
      } catch (error) {
        if (error.response) {
          setErrorState(error.response.data.message);
        }
      }
      setLoading(false);
    },
  });

  const setErrorState = (message) => {
    formik.setErrors({ password: message });
    setTimeout((_) => {
      formik.setErrors("");
    }, 5000);
  };

  return (
    <form noValidate onSubmit={formik.handleSubmit}>
      <div>
        By Account deletion, all your teams, posts & tasks will be permanently
        deleted in 90 days. If you want to assign your teams to some other
        member, you must have to assign them super admin role. Once your request
        to delete account is initiated, you won't be able to access app & You
        will become anonymous user.
      </div>
      <div style={classes.checkedBox}>
        {!checked && (
          <UnChecked
            style={classes.icon}
            onClick={() => setChecked(!checked)}
          />
        )}
        {checked && (
          <Checked style={classes.icon} onClick={() => setChecked(!checked)} />
        )}
        <span>I agree with above terms.</span>
      </div>
      <div style={classes.borderInput}>
        <CustomInput
          id={"password"}
          inputClass="borderInput"
          startIcon={<FontAwesomeIcon icon={faLock} className="formIcon" />}
          inputProps={{
            type: values.showPassword ? "text" : "password",
            placeholder: "Enter Your Password",
            ...formik.getFieldProps("password"),
            error:
              !!formik.errors.password && !!formik.touched.password
                ? formik.errors.password
                : null,
          }}
          style={passwordStyle}
          endIcon={
            <FontAwesomeIcon
              onClick={handleClickShowPassword}
              aria-label="toggle password visibility"
              icon={!values.showPassword ? faEyeSlash : faEye}
              id="togglePassword"
              style={{ marginLeft: "-30px", cursor: "pointer" }}
            />
          }
        />
      </div>
      <div>
        <Button
          name={!loading ? "Delete" : <Loader width={40} height={40} />}
          disabled={(!checked || loading) && true}
        />
      </div>
    </form>
  );
};

const loginValidationSchema = () => {
  return Yup.object().shape({
    password: Yup.string().min(4).required(),
  });
};
